var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailSubmit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "white",
    stroke: "#4D7EFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33138 12.0182L6.15951 9.84635L5.41992 10.5807L8.33138 13.4922L14.5814 7.24219L13.847 6.50781L8.33138 12.0182Z",
    fill: "#4D7EFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSubmit);
export default __webpack_public_path__ + "static/media/email-submit.13e862c4fc51a5e4ebb79463e059280c.svg";
export { ForwardRef as ReactComponent };